import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Platformfeature() {
  return (
    <section className="platform_feature p-100 text_peanut">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="platform_img">
              <StaticImage
                src="../../../images/case-studies/peanut/feature.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={693}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>
              <span>Features</span>
            </h2>
            <p>
              The Peanut Butter Park has several amazing features that help it
              stand out from the rest. The ‘join park’ feature allows dog owners
              to locate dog parks nearby so that they can take their furry
              friends out to play. ‘Peanut alerts’ lets pet parents share alerts
              about their dogs on the app, including pictures, anecdotes, and
              major milestones. With ‘group chats’, not only can dog owners
              connect with other dog owners on the app, but they can also make
              group chats to share stories about their dogs and organize
              playdates. ‘Create park’ gives dog owners the option to create
              their own dog park and list it on the app for other dog owners to
              discover and visit.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Platformfeature;
